<template>
    <v-dialog
        v-model="dialogActive"
        persistent
        max-width="500"
    >
        <v-card>
            <v-card-text>
                <v-container>
                    <v-alert type="success">
                        <h2>Aprovar Hotel</h2>
                    </v-alert>
                    <p class="ml-4 confirm-text">
                        Você realmente deseja aprovar o hotel <span class="font-weight-bold text-uppercase">{{ hotelName }}</span>?
                    </p>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-btn text @click="$emit('close-dialog')">
                    Cancelar
                </v-btn>
                <v-btn color="success" @click="$emit('approve-method')">
                    Aprovar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "ConfirmHotelModal",
    props: [
        'dialogActive',
        'hotelName',
    ],
}
</script>

<style scoped>
.v-dialog .v-card__text, .container {
    padding: 0 !important;
}

.v-dialog .v-alert {
    border-radius: 0 !important;
}

.v-dialog, .v-dialog .v-card__text {
    overflow: hidden !important;
}

.v-card__actions {
    justify-content: flex-end;
}

.confirm-text {
    font-size: 16px;
}
</style>
